<template>
    <div id="collapseSearch" class="collapse position-absolute w-100">
        <div class="d-flex justify-content-between gap-2 bg-white border">
            <input v-model="productSearch"
                   :placeholder="trans('enter_product_name')"
                   class="form-control border-0 p-3 flex-grow-1"
                   type="text"
            >

            <div class="d-flex align-items-center gap-2 p-2">
                <button v-if="productSearch && productSearch.length"
                        class="btn btn-sm border-0"
                        :title="trans('clear')"
                        @click="clearProductSearch()"
                >
                    <i class="fa-solid fa-circle-xmark text-secondary"></i>
                </button>

                <button class="btn btn-sm btn-warning h-100">
                    {{ trans('search') }}
                </button>
            </div>
        </div>

        <div v-if="productSearch && productSearch.length"
             class="bg-white shadow rounded m-lg-3">
            <ul class="d-flex flex-column gap-4 p-3 mb-0 product_search__container">
                <li class="d-flex align-items-center gap-2 product_search__item">
                    <img :src="CarPartPic" width="50" alt="">
                    <span class="fw-bold">მბაპერი</span>
                </li>

                <li class="d-flex align-items-center gap-2 product_search__item">
                    <img :src="CarPartPic2" width="50" alt="">
                    <span class="fw-bold">ამორტიზატორი</span>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import {t} from "@/lang/core/helpers";
import CarPartPic from "@/assets/websites/get-parts/img/car-pic.png"
import CarPartPic2 from "@/assets/websites/get-parts/img/part.png"

export default {
    data() {
        return {
            CarPartPic,
            CarPartPic2,
            productSearch: null,
        }
    },

    watch: {
        productSearch(value) {
            this.searchQuery = value
        }
    },

    methods: {
        trans(key) {
            return t(key)
        },
        clearProductSearch() {
            this.productSearch = null
        }
    },

    computed: {
        searchQuery: {
            get() {
                return this.$store.getters.carPartsProductSearch
            },
            set(newValue) {
                return this.$store.commit('setCarPartsProductSearch', newValue)
            },
        },
    }

}
</script>

<style lang="scss" scoped>
#collapseSearch {
    z-index: 1;
}
.product_search__item {
    position: relative;
}
.product_search__item::before {
    content: "\f002";
    font-family: "Font Awesome 5 Free";
    font-weight: 600;
    color: #dee2e6;
}
.product_search__item::after {
    content: "";
    position: absolute;
    width: calc( 100% + 32px );
    height: 1px;
    background-color: #dee2e6;
    bottom: -10px;
    left: -16px;
}
.product_search__item:last-child::after {
   display: none;
}
</style>